import React from 'react';


export const ChangeThemeContext = React.createContext();


export default ChangeThemeContext;